import * as React from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

type Props = {
  data: string;
  width: number;
  height: number;
  style?: StyleProp<ImageStyle>;
  accessibilityLabel?: string;
};

export const Svg: React.FC<Props> = ({
  data,
  width = 0,
  height = 0,
  style,
  accessibilityLabel,
}) => {
  return (
    <Image
      style={[style, { width, height }]}
      source={{
        uri: `data:image/svg+xml;utf8,${data}`,
      }}
      accessibilityLabel={accessibilityLabel}
    />
  );
};
